import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import {
  ATTACHMENT_EMPTY_MESSAGE_ID,
  ATTACHMENT_ERROR_MESSAGE_ID,
  type AttachmentViewState,
} from '../../utils/getAttachmentViewState';
import styles from './index.module.less';

type AttachmentStatusMessageProps = {
  state: AttachmentViewState;
};

const AttachmentStatusMessage = ({ state }: AttachmentStatusMessageProps) => {
  if (state === 'empty') {
    return (
      <Typography.Text type="secondary">
        <IntlMessages id={ATTACHMENT_EMPTY_MESSAGE_ID} />
      </Typography.Text>
    );
  }

  if (state === 'error') {
    return (
      <Typography.Text type="danger" role="alert" className={styles.error}>
        <ExclamationCircleOutlined className={styles.errorIcon} aria-hidden="true" />
        <IntlMessages id={ATTACHMENT_ERROR_MESSAGE_ID} />
      </Typography.Text>
    );
  }

  return null;
};

export default React.memo(AttachmentStatusMessage);
